export const FILTERS = [
  { key: "none", label: "Original", css: "none", swatch: "#64748B" },
  { key: "aurora", label: "Aurora", css: "saturate(1.35) contrast(1.05)", swatch: "#6366F1" },
  { key: "vintage", label: "Vintage", css: "sepia(0.45) contrast(1.1) brightness(0.95)", swatch: "#B45309" },
  { key: "pb", label: "P&B", css: "grayscale(1) contrast(1.1)", swatch: "#E5E7EB" },
  { key: "calor", label: "Calor", css: "sepia(0.25) saturate(1.4) hue-rotate(-10deg)", swatch: "#F59E0B" },
  { key: "frio", label: "Frio", css: "hue-rotate(15deg) saturate(0.9) brightness(1.05)", swatch: "#38BDF8" },
  { key: "luz", label: "Luz", css: "brightness(1.18) contrast(0.95)", swatch: "#FDE68A" },
];

export const filterCss = (key) => FILTERS.find((f) => f.key === key)?.css || "none";

export const STICKERS = ["🙏", "✝️", "❤️", "🙌", "🕊️", "✨", "🔥", "🎶", "📖", "⛪", "😊", "🌟"];

export const TEXT_COLORS = ["#FFFFFF", "#F59E0B", "#0B0F17", "#F43F5E", "#10B981", "#818CF8"];
